import * as z from "zod";

export const getKlaviyoSubscriptionSync = {
  name: "getKlaviyoSubscriptionSync" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    connected: z.boolean(),
    syncCustomersToRedo: z.boolean(),
  }),
};

export const setKlaviyoSubscriptionSync = {
  name: "setKlaviyoSubscriptionSync" as const,
  input: z.object({ teamId: z.string(), syncCustomersToRedo: z.boolean() }),
  output: z.object({}),
};
